import PropTypes from 'prop-types';

import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledFormControlLabel = styled(FormControlLabel, {
  shouldForwardProp: (prop) => prop !== 'isChecked',
})(({ theme, isChecked }) => ({
  height: '3.8rem',
  backgroundColor: theme.palette.grey[200],
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0 1.5rem 0 0',
  borderRadius: 10,
  margin: 0,
  ...(isChecked && {
    backgroundColor: theme.palette.custom.primary2,
    color: theme.palette.common.white,
  }),
}));

const StyledRadio = ({ icon, label, ...rest }) => {
  const radioIcon = icon ? (
    <img
      style={{
        width: '2.5rem',
        height: '2.5rem',
        borderRadius: '5px',
      }}
      src={icon}
      alt={label}
    />
  ) : (
    <div style={{ display: 'none' }} />
  );
  return (
    <Radio
      disableRipple
      color="default"
      checkedIcon={radioIcon}
      icon={radioIcon}
      sx={{
        '& > span > input': {
          width: 0,
          height: 0,
        },
      }}
      {...rest}
    />
  );
};

StyledRadio.propTypes = {
  icon: PropTypes.string,
  label: PropTypes.string,
};

const ButtonSelectComponent = (props) => {
  const {
    input,
    meta: { touched, error },
    options,
    ...custom
  } = props;
  const hasError = touched && !!error;
  return (
    <FormControl size="small" error={hasError} {...custom}>
      <RadioGroup
        sx={{ flexDirection: 'row', gap: '1rem' }}
        {...input}
        onFocus={input?.onChange}
      >
        {options?.map(({ value, label, icon }) => {
          const isChecked = Number.isInteger(value)
            ? Number(input?.value) === value
            : input?.value === value;
          return (
            <StyledFormControlLabel
              key={value}
              checked={isChecked}
              value={value}
              control={<StyledRadio icon={icon} label={label} />}
              isChecked={isChecked}
              label={label}
            />
          );
        })}
      </RadioGroup>
      {hasError && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

ButtonSelectComponent.propTypes = {
  input: PropTypes.instanceOf(Object).isRequired,
  meta: PropTypes.instanceOf(Object).isRequired,
  options: PropTypes.instanceOf(Array),
};

export default ButtonSelectComponent;
